import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useCustomerListStyles = makeStyles((theme: Theme) => createStyles({
  customerListContainer: {
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > *': {
      width: '80%',
    },
  },
  customerSearch: {
    marginBottom: theme.spacing(2),
  },
  filterBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  deletedItem: {
    opacity: 0.55,
    fontStyle: 'italic',
  },
  deletedLabel: {
    marginLeft: theme.spacing(1),
    fontSize: '0.75rem',
    color: theme.palette.error.main,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  fabIcon: {
    marginRight: theme.spacing(1),
  },
  customerList: {
    width: '100%',
  },
  loadingContainer: {
    width: '100%',
    height: '100%',
    minHeight: '112px',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
  customerListPaper: {
    position: 'relative',
  },
  [theme.breakpoints.down('xs')]: {
    customerListContainer: {
      '& > *': {
        width: '100%',
      },
    },
    customerSearch: {
      marginBottom: theme.spacing(1),
    },
  },
  [theme.breakpoints.up('lg')]: {
    customerListContainer: {
      '& > *': {
        width: '70%',
      },
    },
  },
}));

export default useCustomerListStyles;
